module.exports = __webpack_public_path__ + "static/img/140219.87531da.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/events/140219.png
// module id = gU6H
// module chunks = 0